import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-picture-slider',
  templateUrl: './picture-slider.component.html',
  styleUrls: ['./picture-slider.component.css']
})
export class PictureSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
